import type { NavigationGuardWithThis } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useOUserSettingsStore } from '../stores/use-user-settings-store';
import { isAdminRoute, userHasAdminRole } from '../utils/user-roles';
import { useHAlerts } from '../composables/use-alerts';
import { useHTranslate } from '../composables/use-translate';

export const ADMIN_ACCESS_DENIED_ALERT_ID = 'admin-access-denied';

function notifyAdminAccessDenied() {
  const { hAddAlert } = useHAlerts();

  hAddAlert({
    id: ADMIN_ACCESS_DENIED_ALERT_ID,
    type: 'warning',
    title: useHTranslate('admin_access_denied'),
    closable: true,
    timeout: 8_000,
  });
}

/**
 * Blocks /admin routes for users without the admin role.
 */
export const adminGuard: NavigationGuardWithThis<undefined> = (to) => {
  if (!isAdminRoute(to.path)) {
    return;
  }

  const { oUserSettings } = storeToRefs(useOUserSettingsStore());

  if (userHasAdminRole(oUserSettings.value)) {
    return;
  }

  notifyAdminAccessDenied();
  // Home is `/` (route name `start`). `{ name: 'root' }` does not exist and
  // leaves the initial navigation hanging, so the splash screen never clears.
  return { path: '/' };
};
